export default "__VITE_ASSET__5b05afe2__"